// Home Youtube
let ytContainer = document.querySelector(".ytcontainer");

if (typeof(ytContainer) != 'undefined' && ytContainer != null) {

	// This code loads the IFrame Player API code asynchronously.
	var tag = document.createElement('script');

	tag.src = "https://www.youtube.com/iframe_api";
	var firstScriptTag = document.getElementsByTagName('script')[0];
	firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

	// This function creates an <iframe> (and YouTube player)
	//    after the API code downloads.
	var player;
	function onYouTubeIframeAPIReady() {
		player = new YT.Player('player', {
			// height: '360',
			// width: '640',
			videoId: ytContainer.dataset.id,
			events: {
				'onReady': onPlayerReady,
			},
			playerVars:{
				rel: 0
			}
		});
	};

	// The API will call this function when the video player is ready.
	function onPlayerReady(event) {
		let ytCover = ytContainer.querySelector(".ytcontainer__cover");
		ytCover.addEventListener("click", () => {
			player.playVideo();
			ytCover.classList.add("is-destroyed");	
		});
	}

}




const navbarMenu = document.querySelector('.js-header__nav');
const burgerMenu = document.querySelector('.js-header__trigger');
const overlayMenu = document.querySelector('.header__overlay');
const childrened = document.querySelector('.menu-item-has-children');
const childrenedLink = document.querySelector('.menu-item-has-children > a');

// Toggle Menu Function
burgerMenu.addEventListener('click', toggleMenu);
overlayMenu.addEventListener('click', toggleMenu);

function toggleMenu() {
	navbarMenu.classList.toggle('active');
	overlayMenu.classList.toggle('active');
	burgerMenu.classList.toggle('active');
}

document.addEventListener("DOMContentLoaded", function(event) {
	var flkty = new Flickity( '.partners-carousel', {
		// options
		cellAlign: 'left',
		wrapAround: true,
		groupCells: true,
		autoPlay: 5000,
		contain: true,
		imagesLoaded: true
	});
}); /* end of DOMContentLoaded */

// Collapse SubMenu Function
childrened.addEventListener('click', (e) => {
	if (window.innerWidth <= 992) {

		// If menu-item-child is Expanded, then Collapse It
		if (childrened.classList.contains('active')) {
			collapseSubMenu();
		} else {
			// Collapse the Existing Expanded menu-item-child
			// Expanded the New menu-item-child
			childrened.classList.add('active');
			const subMenu = childrened.querySelector('.sub-menu');
			subMenu.style.maxHeight = subMenu.scrollHeight + 'px';
		}
	}
});

childrenedLink.addEventListener('click', (e) => {
	e.preventDefault();
});

function collapseSubMenu() {
	navbarMenu.querySelector('.menu-item-has-children.active .sub-menu').removeAttribute('style');
	navbarMenu.querySelector('.menu-item-has-children.active').classList.remove('active');
}

// Fixed Resize Screen Function
window.addEventListener('resize', () => {
	if (window.innerWidth > 992) {
		// If navbarMenu is Open, then Close It
		if (navbarMenu.classList.contains('active')) {
			toggleMenu();
		}

		// If menu-item-child is Expanded, then Collapse It
		if (navbarMenu.querySelector('.menu-item-has-children.active')) {
			collapseSubMenu();
		}
	}
});

// Scroll function
const header = document.querySelector('.js-header');

window.addEventListener('scroll',(event) => {
	if (window.scrollY > header.offsetHeight) {
		header.classList.add('shrink');
	} else {
		header.classList.remove('shrink');
	}
});

// https://stackoverflow.com/questions/5388429/javascript-jquery-how-to-check-if-a-string-contain-specific-words
function wordInString(s, word){
  return new RegExp( '\\b' + word + '\\b', 'i').test(s);
}

jQuery(function($) {
	'use strict';
	if ($('.tablepress').length) {
		$('.tablepress tbody').each(function() {
			var table = $(this).parent();
			var td = '';
				
			$(this).find('tr').each(function() {

				td += '<tr class="child"><td class="child" colspan="2"><ul class="dtr-details">';

				$(this).find('td').each(function() {

					var text = $(this).text();

					if ((wordInString(text, 'LUNDI')) || (wordInString(text, 'MARDI')) || (wordInString(text, 'MERCREDI')) || (wordInString(text, 'JEUDI'))
						|| (wordInString(text, 'VENDREDI')) || (wordInString(text, 'SAMEDI')) || (wordInString(text, 'DIMANCHE')) || (wordInString(text, 'TARIFS'))
						|| (wordInString(text, 'À L\'ANNÉE')) || (wordInString(text, 'AU SEMESTRE'))) {

						td += '<li style="background-color: #fdb500; color: #fff; border: none;"><span class="dtr-data">'+$(this).text()+'</span></li>';

						return false;
					} else {

						var clmn = $(this).attr("class");

						var th = '';

						if (table.find('th[class="'+clmn+'"]').text() !== 'TARIFS') {
							th = '<span class="dtr-title">'+table.find('th[class="'+clmn+'"]').text()+'</span>';
						}

						td += '<li>'+th+'<span class="dtr-data">'+$(this).html()+'</span></li>';

					}
				});
				td += '</ul></td></tr>';	
			});
			$(this).append(''+td+'');
		});
	}
});
